
import { createApiClient } from 'Network/ApiClient';

export const ActivityNotAllowedIncludeActivityAxiosInstance = createApiClient('Activity/');


